import { render, staticRenderFns } from "./PreviewAudio.vue?vue&type=template&id=35fa9681&scoped=true&"
import script from "./PreviewAudio.vue?vue&type=script&lang=js&"
export * from "./PreviewAudio.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAudio.vue?vue&type=style&index=0&id=35fa9681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa9681",
  null
  
)

export default component.exports